import { render, staticRenderFns } from "./creativity.vue?vue&type=template&id=21a46bfb"
import script from "./creativity.vue?vue&type=script&lang=js"
export * from "./creativity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports